// //原有配置
// export default {
//   getAPIPrefix:()=>{
//   //return "http://39.106.39.75:8080/";
//   return "http://124.223.11.37:8080/";
//   // return "http://localhost:8001/";
//   // return "http://localhost:8080/";
// },

// getGoAPIPrefix:()=>{
//   //return "http://39.106.39.75:8080/";
//   return "http://124.223.11.37:8001/";
//   // return "http://localhost:8001/";
//   // return "http://localhost:8080/";
// },

// getGoNewAPIPrefix:()=>{
//   // return "http://124.223.11.37:8004/";
//   return "http://124.223.11.37:8003/";
//   // return "http://localhost:8003/";
//   // return "http://localhost:8004/";
// },

// getAliYunAddr:()=>{
//   // return "http://39.106.39.75/";
//   // return "http://localhost:8087/";
//   return "http://124.223.11.37:8082/";
// },
// getCdnAddr:()=>{
//   return "http://124.223.11.37:8082/";
// },
// }


// //医大新服务器配置
// export default {
//   getAPIPrefix:()=>{
//   return "http://210.46.80.153:8080/";
// },

// getGoAPIPrefix:()=>{
//   return "http://210.46.80.153:8001/";
// },

// // getGoNewAPIPrefix:()=>{
// //   return "http://210.46.80.153:8003/";
// // },

// // getAliYunAddr:()=>{
// //   return "http://210.46.80.153:8082/";
// // },
// getAliYunAddr:()=>{
//   return "http://49.232.195.119:8082/";
// },
// //wyk2021
// // getCdnAddr:()=>{
// //   return "http://210.46.80.153:8082/";
// // },
// //改本地配置
// // getGoNewAPIPrefix:()=>{
// //   return "http://127.0.0.1:8003/";
// // },
// // getCdnAddr:()=>{
// //   return "http://127.0.0.1:8082/";
// // },
// //腾讯云配置
// getGoNewAPIPrefix:()=>{
//   return "http://49.232.195.119:8003/";
// },
// getCdnAddr:()=>{
//   return "http://49.232.195.119:8082/";
// },
export default {
  getAliYunAddr: () => {
    return "http://49.233.105.119:8082/";
  },
  getGoNewAPIPrefix: () => {
    return "http://49.233.105.119:8003/";
  },
  getCdnAddr: () => {
    return "http://49.233.105.119:8082/";
  },
}

// }
// 49.233.105.119
//本地测试
//医大新服务器配置
// export default {
//   getAPIPrefix: () => {
//     return "http://210.46.80.153:8080/";
//   },

//   getGoAPIPrefix: () => {
//     return "http://210.46.80.153:8001/";
//   },

//   // getGoNewAPIPrefix:()=>{
//   //   return "http://210.46.80.153:8003/";
//   // },

//   // getAliYunAddr:()=>{
//   //   return "http://210.46.80.153:8082/";
//   // },
//   getAliYunAddr: () => {
//     return "http://localhost:8082/";
//   },
//   //wyk2021
//   // getCdnAddr:()=>{
//   //   return "http://210.46.80.153:8082/";
//   // },
//   //改本地配置
//   // getGoNewAPIPrefix:()=>{
//   //   return "http://127.0.0.1:8003/";
//   // },
//   // getCdnAddr:()=>{
//   //   return "http://127.0.0.1:8082/";
//   // },
//   //腾讯云配置
//   getGoNewAPIPrefix: () => {
//     return "http://localhost:8003/";
//   },
//   getCdnAddr: () => {
//     return "http://localhost:8082/";
//   },


// }





// WEBPACK FOOTER //
// ./src/utils/getAPI.js